import React from 'react';
import config from '../../../utils/config';

function SalesByFloor() {
	return (
		<div id="main-container" className="main-container nav-effect-1">
			<iframe
				style={{ top: '0px' }}
				id="ouilink-iframe"
				src={`${config.reportingV4Url}sales-by-floor${window.location.search}`}
			/>
		</div>
	);
}
export default SalesByFloor;
